export default __webpack_public_path__ + "static/media/Hubano-4Closed.3bf257bf.jpg";